import { IExerciseResultItem } from '../../redux/api/exercises/interfaces';
import { IProgramSetItemOption } from '../../types/interfaces/program-set-item-option';
import { ITrainingSetItemOption } from '../../types/interfaces/training-set-item-option';

export function findExerciseResultByExerciseId(
  exerciseResults: IExerciseResultItem[] | undefined | null,
  exerciseId: string | undefined | null,
): IExerciseResultItem | undefined {
  if (!exerciseResults?.length || exerciseId == null || exerciseId === '') {
    return undefined;
  }
  const needle = String(exerciseId);
  return exerciseResults.find((r) => String(r.exerciseId) === needle);
}

export function mergeProgramResultIntoOptions(
  options: IProgramSetItemOption[],
  result: IExerciseResultItem | undefined,
): IProgramSetItemOption[] {
  if (!result) return options;
  return options.map((option) => {
    const resultOption = result.trainingSetItem.trainingSetItemOptions.find(
      (o) => String(o.optionId) === String(option.optionId),
    );
    if (!resultOption) return option;
    return {
      ...option,
      value: resultOption.value,
      value2: resultOption.value2,
    };
  });
}

export function mergeTrainingResultIntoOptions(
  options: ITrainingSetItemOption[],
  result: IExerciseResultItem | undefined,
): ITrainingSetItemOption[] {
  if (!result) return options;
  return options.map((option) => {
    const resultOption = result.trainingSetItem.trainingSetItemOptions.find(
      (o) => String(o.optionId) === String(option.optionId),
    );
    if (!resultOption) return option;
    return {
      ...option,
      programValue: resultOption.value,
      programValue2: resultOption.value2,
    };
  });
}
